import { RouterProvider } from '@tanstack/react-router';
import { router } from './providers/router';
import 'ui_2/src/index.css';

function App() {
  return (
    <div className='h-[100dvh]	w-screen bg-slate-800'>
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
